export interface VehicleBrandSource {
  label: string;
  url: string;
}

export interface VehicleBrandVideo {
  video_id: string;
  title: string;
  channel_title: string;
  published_at: string;
  thumbnail_url: string;
  view_count?: number | null;
  youtube_url: string;
  source: "YouTube" | string;
}

export interface VehicleBrandRecord {
  slug: string;
  name: string;
  entity_type: "company" | string;
  category: string;
  aliases?: string[];
  description: string;
  source: VehicleBrandSource;
  image?: string | null;
  image_alt?: string | null;
  youtube_enabled?: boolean;
  youtube_search_query?: string;
  videos?: VehicleBrandVideo[];
}

export interface VehicleBrandResolveResponse {
  matched: boolean;
  brand: VehicleBrandRecord | null;
}

const VEHICLE_BRAND_RESOLVE_URL =
  "https://api.ayesearch.com/api/vehicles/resolve/";

export async function resolveVehicleBrand(
  query: string,
): Promise<VehicleBrandResolveResponse> {
  const url = new URL(VEHICLE_BRAND_RESOLVE_URL);
  url.searchParams.set("q", query);

  const response = await fetch(url.toString(), {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Vehicle brand lookup failed (${response.status})`);
  }

  return (await response.json()) as VehicleBrandResolveResponse;
}
